import yup from 'utils/yup';

export const initialTaskFormData = {
  id: '',
  name: '',
  billable: [] as any,
  billable_rate: 0,
  description: '',
  jobs: [] as any,
};

export const taskFormValidationSchema = yup.object().shape({
  name: yup.string().required(),
  billable: yup.array().of(yup.string()),
  billable_rate: yup.number().when('billable', {
    is: (value: any) => value.length > 0,
    then: yup.number().required(),
    otherwise: yup.number(),
  }),
});
